import { useMutation } from '@apollo/client';

import { RemoveRoleInput } from '../../apollo/__generated__/graphql';
import { REMOVE_ROLE } from '../graphql/mutation/removeRoleMutation.graphql';

export const useRemoveRoleMutation = () => {
  const [mutate] = useMutation(REMOVE_ROLE);

  const removeRole = (removeRoleInput: RemoveRoleInput) => {
    mutate({
      variables: {
        removeRoleInput,
      },
    });
  };

  return { removeRole };
};
